module.exports = __webpack_public_path__ + "static/media/fake-data-json.312b8a35.jpg";